export default {
      id: "icon_stats_corner-usage",
      viewBox: "0 0 9 10",
      url: "/" + "images/icons.3.109.2.svg#icon_stats_corner-usage",
      toString: function () {
        return this.url;
      }
    }